var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDinersClub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Extra",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-diners-club",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,17.3333333 C28,18.8 26.8,20 25.3333333,20 L2.66666667,20 C1.2,20 0,18.8 0,17.3333333 L0,2.66666667 C0,1.2 1.2,0 2.66666667,0 L25.3333333,0 C26.8,0 28,1.2 28,2.66666667 L28,17.3333333 Z",
    id: "Path",
    fill: "#CFD8DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3333333,4.66666667 L10.6666667,4.66666667 C7.73333333,4.66666667 5.33333333,7.06666667 5.33333333,10 C5.33333333,12.9333333 7.73333333,15.3333333 10.6666667,15.3333333 L17.3333333,15.3333333 C20.2666667,15.3333333 22.6666667,12.9333333 22.6666667,10 C22.6666667,7.06666667 20.2666667,4.66666667 17.3333333,4.66666667 Z",
    id: "Path",
    fill: "#1565C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6666667,6 C8.46666667,6 6.66666667,7.8 6.66666667,10 C6.66666667,12.2 8.46666667,14 10.6666667,14 C12.8666667,14 14.6666667,12.2 14.6666667,10 C14.6666667,7.8 12.8666667,6 10.6666667,6 Z M8,10 C8,8.73333333 8.86666667,7.73333333 10,7.4 L10,12.5333333 C8.86666667,12.2666667 8,11.2666667 8,10 Z M11.3333333,12.6 L11.3333333,7.46666667 C12.4666667,7.73333333 13.3333333,8.8 13.3333333,10.0666667 C13.3333333,11.2666667 12.4666667,12.2666667 11.3333333,12.6 Z",
    id: "Shape",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDinersClub);
export default __webpack_public_path__ + "static/media/icon-diners-club.c02b893b5ca2e2bcb5060ad8901d9fcc.svg";
export { ForwardRef as ReactComponent };